import { render, staticRenderFns } from "./ProgramAddModal.vue?vue&type=template&id=aa4bcc10&"
import script from "./ProgramAddModal.vue?vue&type=script&lang=js&"
export * from "./ProgramAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports